/**
 * Main JavaScript file for Takumo Theme
 */

// Import responsive images functionality
import ResponsiveImages from './responsive-images.js';

(function ($) {
    'use strict';

    // DOM Ready
    $(document).ready(function () {
        initMobileMenu();
        initSmoothScrolling();
        initFormValidation();
        initScrollToTop();
        initArticleDownloadPopup();
        handleHashOnLoad();
    });

    /**
     * Initialize mobile menu functionality
     */
    function initMobileMenu() {
        const menuToggle = $('.menu-toggle');
        const navMenuWrapper = $('.nav-menu-wrapper');
        const mainNavigation = $('.main-navigation');
        const body = $('body');

        menuToggle.on('click', function (e) {
            e.preventDefault();

            const isExpanded = $(this).attr('aria-expanded') === 'true';

            $(this).attr('aria-expanded', !isExpanded);
            $(this).toggleClass('is-active');
            navMenuWrapper.toggleClass('is-open');
            mainNavigation.toggleClass('menu-open');
            body.toggleClass('mobile-menu-open');

            // Trap focus within menu when open
            if (!isExpanded) {
                navMenuWrapper.find('a').first().focus();
            }
        });

        // Close menu when clicking outside
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.main-navigation').length) {
                menuToggle.attr('aria-expanded', 'false');
                menuToggle.removeClass('is-active');
                navMenuWrapper.removeClass('is-open');
                mainNavigation.removeClass('menu-open');
                body.removeClass('mobile-menu-open');
            }
        });

        // Close menu on escape key
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && navMenuWrapper.hasClass('is-open')) {
                menuToggle.attr('aria-expanded', 'false');
                menuToggle.removeClass('is-active');
                navMenuWrapper.removeClass('is-open');
                mainNavigation.removeClass('menu-open');
                body.removeClass('mobile-menu-open');
                menuToggle.focus();
            }
        });

        // Handle menu item clicks on mobile
        navMenuWrapper.find('a').on('click', function () {
            if (window.innerWidth < 1024) {
                menuToggle.attr('aria-expanded', 'false');
                menuToggle.removeClass('is-active');
                navMenuWrapper.removeClass('is-open');
                mainNavigation.removeClass('menu-open');
                body.removeClass('mobile-menu-open');
            }
        });
    }

    /**
     * Initialize smooth scrolling for anchor links
     */
    function initSmoothScrolling() {
        $('a[href*="#"]:not([href="#"])').on('click', function (e) {
            const target = $(this.hash);

            if (target.length) {
                e.preventDefault();

                // Use native smooth scroll for better performance and consistency
                const targetPosition = target.offset().top - 80; // Account for fixed header

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    }

    /**
     * Handle hash in URL on page load
     */
    function handleHashOnLoad() {
        if (window.location.hash) {
            const hash = window.location.hash;
            const target = $(hash);

            if (target.length) {
                // Small delay to ensure page is fully loaded
                setTimeout(function () {
                    const targetPosition = target.offset().top - 80; // Account for fixed header

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }, 100);
            }
        }
    }

    /**
     * Initialize scroll to top functionality for brand logo/text
     */
    function initScrollToTop() {
        $('.js-scroll-to-top').on('click', function (e) {
            const currentUrl = window.location.href.split('#')[0];
            const linkUrl = this.href.split('#')[0];

            // If we're on the same page (or homepage), scroll to top instead of navigating
            if (currentUrl === linkUrl || window.scrollY > 0) {
                e.preventDefault();

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });

                // Update URL to homepage if clicking from a different page
                if (currentUrl !== linkUrl) {
                    setTimeout(function () {
                        window.location.href = linkUrl;
                    }, 500);
                }
            }
        });
    }

    /**
     * Initialize first-visit article download popup.
     */
    function initArticleDownloadPopup() {
        const popup = document.querySelector('[data-article-popup]');

        if (!popup) {
            return;
        }

        const storageKey = popup.dataset.storageKey || 'takumo_article_popup_seen';
        const popupTriggers = document.querySelectorAll('[data-article-popup-trigger]');
        const formPanel = popup.querySelector('[data-article-popup-form]');
        const form = formPanel ? formPanel.querySelector('.wpcf7-form') : null;
        const closeButtons = popup.querySelectorAll('[data-article-popup-close]');
        const primaryVersion = popup.dataset.primaryVersion === 'jp' ? 'jp' : 'en';
        let selectedVersion = '';
        let downloadStarted = false;
        let automaticOpenTimer = null;

        function resetPopup() {
            downloadStarted = false;

            if (form) {
                form.reset();
            }

            setSelectedVersion(primaryVersion);
        }

        function openPopup() {
            resetPopup();
            popup.hidden = false;
            document.body.classList.add('article-popup-open');

            const firstField = formPanel ? formPanel.querySelector('input:not([type="hidden"]), button, textarea, select') : null;

            if (firstField) {
                firstField.focus();
            }
        }

        function closePopup() {
            popup.hidden = true;
            document.body.classList.remove('article-popup-open');
        }

        function setSelectedVersion(version) {
            selectedVersion = version;

            const hiddenField = formPanel ? formPanel.querySelector('input[name="article-version"]') : null;

            if (hiddenField) {
                hiddenField.value = version.toUpperCase();
            }
        }

        function startDownload() {
            if (downloadStarted || !selectedVersion) {
                return;
            }

            const url = selectedVersion === 'jp' ? popup.dataset.downloadJpUrl : popup.dataset.downloadEnUrl;

            if (!url) {
                return;
            }

            downloadStarted = true;
            window.location.href = url;
            closePopup();
        }

        popupTriggers.forEach(function (trigger) {
            trigger.addEventListener('click', function (event) {
                event.preventDefault();

                if (automaticOpenTimer !== null) {
                    clearTimeout(automaticOpenTimer);
                    automaticOpenTimer = null;
                }

                openPopup();
            });
        });

        let showAutomatically = true;

        try {
            if (window.localStorage.getItem(storageKey)) {
                showAutomatically = false;
            } else {
                window.localStorage.setItem(storageKey, '1');
            }
        } catch (error) {
            // If storage is blocked, still show once for the current page load.
        }

        if (showAutomatically) {
            automaticOpenTimer = setTimeout(function () {
                automaticOpenTimer = null;
                openPopup();
            }, 600);
        }

        closeButtons.forEach(function (button) {
            button.addEventListener('click', closePopup);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && !popup.hidden) {
                closePopup();
            }
        });

        if (formPanel) {
            formPanel.addEventListener('click', function (event) {
                const button = event.target.closest('.takumo-article-popup-version-button');

                if (!button) {
                    return;
                }

                setSelectedVersion(button.classList.contains('takumo-article-popup-version-button-jp') ? 'jp' : 'en');
            });
        }

        document.addEventListener('wpcf7mailsent', function (event) {
            if (formPanel && formPanel.contains(event.target)) {
                startDownload();
            }
        });

        document.addEventListener('wpcf7submit', function (event) {
            if (formPanel && formPanel.contains(event.target) && event.detail && event.detail.status === 'mail_sent') {
                startDownload();
            }
        });
    }

    /**
     * Initialize form validation and enhancement
     */
    function initFormValidation() {
        // Exclude Contact Form 7 forms as they have their own validation system
        const forms = $('.form, .contact-form form').not('.wpcf7-form');

        forms.each(function () {
            const form = $(this);

            // Add floating labels
            form.find('input, textarea').on('focus blur', function () {
                const field = $(this);
                const label = field.siblings('label');

                if (field.val() || field.is(':focus')) {
                    label.addClass('is-floating');
                } else {
                    label.removeClass('is-floating');
                }
            });

            // Real-time validation
            form.find('input[required], textarea[required]').on('blur', function () {
                validateField($(this));
            });

            // Form submission
            form.on('submit', function (e) {
                let isValid = true;

                form.find('input[required], textarea[required]').each(function () {
                    if (!validateField($(this))) {
                        isValid = false;
                    }
                });

                if (!isValid) {
                    e.preventDefault();
                    form.find('.form__error').first().focus();
                }
            });
        });
    }

    /**
     * Validate individual form field
     */
    function validateField(field) {
        const value = field.val().trim();
        const type = field.attr('type');
        let isValid = true;
        let errorMessage = '';

        // Remove existing error states
        field.removeClass('is-invalid');
        field.siblings('.form__error').remove();

        // Required field validation
        if (field.prop('required') && !value) {
            isValid = false;
            errorMessage = 'This field is required.';
        }

        // Email validation
        if (type === 'email' && value) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                isValid = false;
                errorMessage = 'Please enter a valid email address.';
            }
        }

        // Phone validation
        if (type === 'tel' && value) {
            const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
            if (!phoneRegex.test(value.replace(/[\s\-\(\)]/g, ''))) {
                isValid = false;
                errorMessage = 'Please enter a valid phone number.';
            }
        }

        // Display error if invalid
        if (!isValid) {
            field.addClass('is-invalid');
            field.after('<div class="form__error">' + errorMessage + '</div>');
        }

        return isValid;
    }

    /**
     * Initialize scroll-based animations
     */
    function initScrollAnimations() {
        const animatedElements = $('.animate-on-scroll');

        function checkScroll() {
            animatedElements.each(function () {
                const element = $(this);
                const elementTop = element.offset().top;
                const elementBottom = elementTop + element.outerHeight();
                const viewportTop = $(window).scrollTop();
                const viewportBottom = viewportTop + $(window).height();

                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    element.addClass('is-visible');
                }
            });
        }

        $(window).on('scroll', checkScroll);
        checkScroll(); // Check on load
    }

    // Initialize scroll animations
    initScrollAnimations();

    /**
     * Accessibility enhancements
     */
    function initAccessibility() {
        // Skip link functionality
        $('.skip-link').on('click', function (e) {
            const target = $($(this).attr('href'));
            if (target.length) {
                target.attr('tabindex', '-1').focus();
            }
        });

        // Focus management for modals/dropdowns
        $(document).on('keydown', function (e) {
            // Trap focus in open mobile menu
            if ($('.primary-menu').hasClass('is-open') && e.key === 'Tab') {
                const focusableElements = $('.primary-menu').find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
                const firstElement = focusableElements.first();
                const lastElement = focusableElements.last();

                if (e.shiftKey && document.activeElement === firstElement[0]) {
                    e.preventDefault();
                    lastElement.focus();
                } else if (!e.shiftKey && document.activeElement === lastElement[0]) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        });
    }

    // Initialize accessibility features
    initAccessibility();

})(jQuery);
